import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import VueSession from "vue-session";

import router from './router'
import '@/assets/css/global.css'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.config.productionTip = false

const firebaseConfig = {
  apiKey: "AIzaSyAneUifnjITlPaiDWn3DF3DuBNfgeya1Ng",
  authDomain: "aerialoop-fleet-management.firebaseapp.com",
  databaseURL: "https://aerialoop-fleet-management-default-rtdb.firebaseio.com",
  projectId: "aerialoop-fleet-management",
  storageBucket: "aerialoop-fleet-management.appspot.com",
  messagingSenderId: "1091895789021",
  appId: "1:1091895789021:web:2c2080074b5759d505a234",
  measurementId: "G-4RXSK3FGKT"
};

import { initializeApp } from "firebase/app";
initializeApp(firebaseConfig);

Vue.use(VueSession);
Vue.use(VueApexCharts)
Vue.use(VueRouter)
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)

new Vue({
  router,
  render: (h) => h(App)
}).$mount('#app')
